// extracted by mini-css-extract-plugin
export default {"CustomerListItemContainer":"style_CustomerListItemContainer__BGXEN","namePhoneContainer":"style_namePhoneContainer__-Rpz7"};